/* eslint-disable @typescript-eslint/naming-convention */

import {FilterType} from 'plugins/modules/filter/types';

export const COMBO_FILTER_URL_ROUTE = '(?<tagCode>[a-z_0-9-]+)-tag-(?<tagId>[0-9]+)';
export const ROUTER_QUERY_TAG_OR_COLLECTION_KEY = 'slug';

export const FILTER_URL_SLUG = '/filter/';

export const FILTER_URL_PARAMS = {
    AND: 'and',
    FROM: 'from',
    OR: 'or',
    TO: 'to',
};

export const FILTER_URL_PARAMS_SEPARATOR = '-';

export const API_QUERY_FILTER_NAME = 'filter';

export const API_QUERY_FILTER_PARAMS = {
    FROM: 'from',
    TO: 'to',
};

export const FILTER_URL_SORT_PRIORITY_QUEUE = [
    'color',
    'sugar_type',
    'country',
    'region',
    'grape',
    'drink_type',
    'drink_category',
];

export const FILTER_SHOW_SEARCH_THRESHOLD = 3;

// eslint-disable-next-line no-shadow
export enum WineryBannerType {
    CLOSE = 'CLOSE',
    HURRY_UP = 'HURRY_UP',
}

export const CHECKBOX_TYPES = [
    FilterType.CHECKBOX_AND,
    FilterType.CHECKBOX_OR,
    FilterType.CHECKBOX_OR_WINERY,
    FilterType.CHECKBOX_WITH_DESC,
];

export const RANGE_TYPES = [FilterType.RANGE, FilterType.RANGE_WITH_GROUP];
